var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mx-loader d-flex align-center justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","width":"4","size":"80"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }